import { AutoridadProps } from "../catalogos/AutoridadInterface";
import { TipoConsecutivoProps } from "../catalogos/TipoConsecutivoInterface";

// Definición de defaults

export const defaultConsecutivo: ConsecutivoProps = {
    idConsecutivo:      0,
    numeroConsecutivo:  0,
    anio:               0,
    idTipoConsecutivo:  0,
}

// Creación de interfaces

export interface ConsecutivoProps {
    idConsecutivo:          number;
    numeroConsecutivo:      number;
    anio:                   number;
    idTipoConsecutivo:      number;
    tipoConsecutivo?:       TipoConsecutivoProps;
    idAutoridad?:           number;
    autoridad?:             AutoridadProps;
}